import React, { useEffect, useState, useRef } from "react";
import { fetchDataWithRetries } from "../../Component/function/FunctionApi";

const GovernorateSelector = ({
  value,
  onChange,
  label = "اختر المحافظة",
  required = false,
  error = "",
  includeEmptyOption = true,
  emptyOptionLabel = "اختر المحافظة",
}) => {
  const [governorates, setGovernorates] = useState([]);
  const [filtered, setFiltered] = useState([]);
  const [search, setSearch] = useState("");
  const [selected, setSelected] = useState(null);
  const [showDropdown, setShowDropdown] = useState(false);
  const containerRef = useRef(null);

  useEffect(() => {
    fetchDataWithRetries("Governorate/get-Governorates", (data) => {
      setGovernorates(data?.data || []);
    });
  }, []);

  useEffect(() => {
    const result = governorates.filter((g) =>
      g.name.toLowerCase().includes(search.toLowerCase())
    );
    setFiltered(
      includeEmptyOption ? [{ id: "", name: emptyOptionLabel }, ...result] : result
    );
  }, [search, governorates]);

  useEffect(() => {
    const gov = governorates.find((g) => g.id === value);
    setSelected(gov || null);
    setSearch(gov?.name || "");
  }, [value, governorates]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (containerRef.current && !containerRef.current.contains(event.target)) {
        setShowDropdown(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleSelect = (gov) => {
    setSelected(gov);
    setSearch(gov.name);
    setShowDropdown(false);
    onChange?.({
      target: {
        value: gov?.id || "",
        name: "governorateId",
      },
    });
  };

  return (
    <div className="w-full relative text-right" ref={containerRef}>
      {label && (
        <label className="block mb-1 text-sm font-medium text-gray-700">{label}</label>
      )}

      <div className="relative">
        <input
          type="text"
          className={`w-full border ${
            error ? "border-red-500" : "border-gray-300"
          } rounded-lg px-4 py-2 pr-10 focus:outline-none focus:ring-2 focus:ring-blue-500`}
          placeholder={emptyOptionLabel}
          value={search}
          onChange={(e) => {
            setSearch(e.target.value);
            setShowDropdown(true);
          }}
          onFocus={() => setShowDropdown(true)}
          required={required}
          dir="rtl"
        />

        {/* Dropdown Arrow */}
        <div className="absolute inset-y-0 left-0 flex items-center pr-3 pointer-events-none">
          <svg
            className="w-4 h-4 text-gray-400"
            viewBox="0 0 20 20"
            fill="currentColor"
          >
            <path d="M10 12l-4-4h8l-4 4z" />
          </svg>
        </div>
      </div>

      {error && <p className="text-red-500 text-sm mt-1">{error}</p>}

      {showDropdown && (
        <ul className="absolute top-16 z-20 mt-1 w-full max-h-60 overflow-y-auto bg-white border border-gray-200 rounded-lg shadow-md animate-fadeIn text-sm">
          {filtered.length === 0 ? (
            <li className="px-4 py-2 text-gray-500">لا توجد نتائج</li>
          ) : (
            filtered.map((gov) => (
              <li
                key={gov.id}
                className="px-4 py-2 hover:bg-blue-100 cursor-pointer transition-colors text-right"
                onClick={() => handleSelect(gov)}
              >
                {gov.name}
              </li>
            ))
          )}
        </ul>
      )}
    </div>
  );
};

export default GovernorateSelector;
